export default __webpack_public_path__ + "d98fd1cadc8fb1719a6ea4244cebbe9f.png";